import { render } from "./TrainedTasks.vue?vue&type=template&id=790d44d8"
import script from "./TrainedTasks.vue?vue&type=script&lang=js"
export * from "./TrainedTasks.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__